import { Environment } from '@abp/ng.core';

const baseUrl = 'https://prose-dev.delaware.pro';

export const environment = {
  production: true,
  application: {
    baseUrl,
    name: 'Dev',
    logoUrl: '',
  },
  oAuthConfig: {
    issuer: 'https://prose-dev-auth.delaware.pro',
    redirectUri: baseUrl,
    clientId: 'Prose_App',
    responseType: 'code',
    scope: 'offline_access Prose',
    requireHttps: true,
  },
  apis: {
    default: {
      url: 'https://prose-dev-api.delaware.pro',
      rootNamespace: 'Delaware.Prose',
    },
  },
} as Environment;
